import Vue from 'vue'
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import config from '../../config/app'
Vue.use(CxltToastr)

export default {
  data () {
    return {
      notifyIcons: {
        success: config.host + '/static/uploads/notify_success.png',
        error: config.host + '/static/uploads/notify_error.png',
        warning: config.host + '/static/uploads/notify_warning.png',
        info: config.host + '/static/uploads/notify_info.png'
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    bToast (type, message, title = '', delay = 0, position = 'top center') {
      this.$toast.removeAll()
      this.$toast.success({
        position: position,
        icon: this.notifyIcons[type],
        type: type,
        showDuration: 1000,
        hideDuration: 0,
        closeButton: true,
        hideMethod: 'pulse',
        timeOut: 3000,
        delay: 0,
        color: this.bGetTypeToastColor(type),
        title: title !== '' ? title : (this.$options.filters.capitalize(type)),
        message: message
      })
    },
    bGetTypeToastColor (type) {
      let color = ''
      switch (type) {
        case 'success' :
          // color = '#dff0d8'
          color = '#51A351'
          break
        case 'error' :
          // color = '#f2dede'
          color = '#DB4941'
          break
        case 'warning' :
          // color = '#fcf8e3'
          color = '#E9AD58'
          break
        case 'info' :
          // color = '#d9edf7'
          color = '#2F96B4'
          break
        default :
          color = '#51A351'
          break
      }
      return color
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/mixin/Notification.js